module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _vm._v("Copyright")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Hold the Dream"), _c('br'), _vm._v("Copyright © 1985, 2014 by Barbara Taylor Bradford"), _c('br'), _vm._v("Cover art, special contents, and Electronic Edition © 2014 by RosettaBooks LLC")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. No part of this book may be used or reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer who may quote brief passages in a review.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Cover jacket design by Alexia Garaventa"), _c('br'), _vm._v("ISBN e-Pub edition: 9780795338557")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c4c7e48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780795338557_epub_cop_r1.vue
// module id = 63
// module chunks = 0